import { Box } from "@samdesk/components/Box";
import { Button } from "@samdesk/components/Button";
import { Heading } from "@samdesk/components/Heading";
import { Stack } from "@samdesk/components/Stack";
import { Text } from "@samdesk/components/Text";
import { AnimatedMarker } from "ui-library/AnimatedMarker";

export const ErrorComponent = () => {
	return (
		<Box style={errorComponentWrapper}>
			<Stack direction="column" spacing="large" alignItems="center">
				<AnimatedMarker />
				<Heading align="center" level="2">
					Oops! Something went wrong.
				</Heading>
				<Text align="center" weight="bold">
					Samdesk is on it. Please try reloading the app. Thanks for your
					patience!
				</Text>
				<Button
					label="Reload this page"
					onClick={() => window.location.reload()}
				/>
			</Stack>
		</Box>
	);
};

const errorComponentWrapper = {
	marginTop: "10%",
	marginBottom: "10%",
};
